module.exports = __webpack_public_path__ + "img/Weapon_277.d5f551cd.png";